module.exports = __webpack_public_path__ + "img/becomeChef.594ed2ce.webp";